exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1yQtNWIT7HSPYALI9wOioP{padding-left:.71429rem}", ""]);

// exports
exports.locals = {
	"ProgressCardTd": "_1yQtNWIT7HSPYALI9wOioP"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/TableView/Tds/ProgressCardTd/style.postcss
// module id = 1263
// module chunks = 0